/**
 * Horloge injectable.
 *
 * Le backoff de la file d'attente plafonne à 5 minutes : le tester en temps
 * réel prendrait un quart d'heure par exécution. Tout le code de synchronisation
 * lit l'heure ici, ce qui permet aux tests de la piloter.
 */
export interface Horloge {
  /** Epoch en millisecondes. */
  maintenant(): number
  /** Horodatage ISO 8601 en UTC. */
  iso(): string
}

export const horlogeSysteme: Horloge = {
  maintenant: () => Date.now(),
  iso: () => new Date().toISOString(),
}

/** Horloge contrôlée, pour les tests. */
export function horlogeFigee(depart = 0): Horloge & { avancer(ms: number): void } {
  let t = depart
  return {
    maintenant: () => t,
    iso: () => new Date(t).toISOString(),
    avancer: (ms: number) => {
      t += ms
    },
  }
}
